// import components
import { styled, Box, BoxProps, alpha } from '@mui/material';
import { Icon } from '@sdb/planning-ui';

export const StyledCustomTreeDataContainerBox = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'rowNodeDepth'
})<{ rowNodeDepth: number }>(({ rowNodeDepth }) => ({
  marginLeft: rowNodeDepth
}));

export const StyledTreeDataParentBox = styled(Box)<BoxProps>(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(0.5)
}));

export const StyledTreeDataChildBox = styled(Box)<BoxProps>(({ theme }) => ({
  marginLeft: theme.spacing(8.5)
}));

export const StyledTreeDataIconBox = styled(Box)<BoxProps>(({ theme }) => ({
  cursor: 'pointer',
  color: alpha(theme.palette.text.primary, 0.5),
  display: 'flex',
  alignItems: 'center',
  borderRadius: '50%',
  padding: theme.spacing(1),

  '&:hover': {
    backgroundColor: alpha(theme.palette.common.black, 0.05)
  }
}));

export const StyledTreeDataIcon = styled(Icon)(({ theme }) => ({
  marginRight: theme.spacing(2)
}));
